import axios from 'axios';
import { Message } from 'view-design';
import config from '../../config';

// 创建axios实例
const service = axios.create({
  baseURL: config.baseURL,
  timeout: 3000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const commonParameters = {
      token: '',
    };
    config.params = {
      ...config.params,
      ...commonParameters,
    };

    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  },
);

// 添加响应拦截器
service.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    let result = response.data;
    return Promise.resolve(result);
  },
  function (error) {
    // 对响应错误做点什么
    Message.error('请求出错');
    return Promise.reject(error);
  },
);

export default service;
